export enum RemoveFromTeamSteps {
  Details = "details",
  Result = "result",
}
